import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlobUrlManager } from 'apps/idl/src/modules/filesystem/BlobUrlManager';
import { IPatient } from '../../../../../modules/patients/model/IPatient';

@Component({
  selector: 'di-confirmation-suppression',
  templateUrl: './confirmation-suppression.component.html',
  styleUrls: ['./confirmation-suppression.component.scss'],
})
export class ConfirmationSuppressionComponent implements OnInit {

	isLargeScreen: boolean = false;
	private readonly moBlobUrlManager = new BlobUrlManager();

	@Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

	@Input() patient : IPatient;

  constructor() {}

  ngOnInit(): void {
	
  }
 

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
  

}
